import { AfterViewInit, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PromptField{
    label:string;
    mensagem:string;
    type:string;
    value?:object;
    controlName:string;
    options?:{key?:string, value?:string}[]
}

@Component({
    selector: 'app-prompt-save-dialog-multiple',
    templateUrl: './prompt-save-dialog-multiple.component.html',
    styleUrls: ['./prompt-save-dialog-multiple.component.scss'],
    standalone: false
})
export class PromptSaveDialogComponentMultiple implements OnInit {

  value = '';
  title='';
  fillControl:UntypedFormGroup;/* = new FormControl('', [
    Validators.required
  ]);*/
  
  fields:PromptField[] = [];
  

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>, private fb:UntypedFormBuilder) {
       this.fillControl = this.fb.group({});
       this.fields = data.fields;
       this.title = data.title;
   }

  ngOnInit() {
      this.fields.forEach(data=>{
        this.fillControl.addControl(data.controlName,new UntypedFormControl(data.value != null ? data.value : "",[Validators.required]));
      });
  }


  closeDialog(){
    this.dialogRef.close(false);
  }

  salvar(){
    if (!this.fillControl.valid) {
      this.fillControl.markAllAsTouched();
      return;
    }else{
      // o antigo template sincronizava item.value via [(ngModel)]; agora vem do form
      this.fields.forEach(f => f.value = this.fillControl.get(f.controlName).value);
      this.dialogRef.close(JSON.stringify(this.fields));
    }
  }
}
